/**
 * main.js
 * Here we handle polyfills and bootstraping, then we start app. (the actual starting point is in app.js).
 * @see {@link http://usejsdoc.org} for information about comments standard used.
 * @version 3.0.0
*/
import {
    applyPolyfills
} from './components/polyfill/polyfill';


// Needed for IE support (IE11, IE9, IE8)
applyPolyfills();

// Start the app.
import App from './app';
new App();
